import { render, staticRenderFns } from "./GroupsByModuleItem.vue?vue&type=template&id=d0b5f8c4"
import script from "./GroupsByModuleItem.vue?vue&type=script&lang=js"
export * from "./GroupsByModuleItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports